import { useRoute } from '#imports'
import { ref, watch } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { useRequests } from './useRequests'

function useFetchRatingDetailsSummary() {
  const route = useRoute()

  const requests = useRequests()

  if (!requests || !('getRatingDetailsSummary' in requests))
    return { data: ref(), error: ref() }

  return useHttpFetch(requests.getRatingDetailsSummary, {
    pathParams: route.params,
  })
}

export function useRatingDetailsSummary() {
  const route = useRoute()
  const logger = useLogger()

  const { data: summaryResponse, error } = useFetchRatingDetailsSummary()

  watch(
    error,
    () => {
      if (error.value instanceof Error) {
        logger.error(`[REVIEWS][${route.name?.toString()}]`, {
          error: error.value,
        })
      }
    },
    { immediate: true },
  )

  return {
    summaryResponse,
  }
}
